import { React, useEffect, useReducer, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form,  Select, Input } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, PlusOutlined, EditOutlined, DeleteOutlined, ScheduleOutlined} from '@ant-design/icons';

import axios from 'axios';
import dfosreducer from './reducer';
import { useNavigate } from 'react-router-dom';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useAuth } from '../../Context';
import { useFormik } from 'formik';
import { ADD_DFOS_LIST, ADD_DFOS_LIST_ERROR, ADD_DFOS_LIST_SUCCESS, DELETE_DFOS_LIST, DELETE_DFOS_LIST_ERROR, DELETE_DFOS_LIST_SUCCESS, DFOS_LIST, DFOS_LIST_DETAILS, DFOS_LIST_DETAILS_ERROR, DFOS_LIST_DETAILS_SUCCESS, DFOS_LIST_ERROR, DFOS_LIST_SUCCESS, EDIT_DFOS_LIST, EDIT_DFOS_LIST_ERROR, EDIT_DFOS_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS } from './constants';
const { Title } = Typography;



export default function DfosManagement() {


	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {  dfos : [], details: null, loading: false, error: false, users_data : []};
	const [data, dispatch] = useReducer(dfosreducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteDfosModal, setShowDeleteDfosModal] = useState(false);
	
	const {pidsData, getPids} = useAuth();
	const navigate = useNavigate();
	
	

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);



	const columns = [

		
		{
			title: `${langdata && langdata.Name ? langdata.Name:'Name'}`,
			dataIndex: 'name',
			key: 'name',
			
		},

		{
			title: `${langdata && langdata.UserName ? langdata.UserName:'User Name'}`,
			dataIndex: 'username',
			key: 'username',
			
		},
		{
			title: `${langdata && langdata.PIDS ? langdata.PIDS:'PIDS'}`,
			dataIndex: 'pidsname',
			key: 'pidsname',
		},
	
	];

	if(permission==='superadmin' || permission === 'admin'){
		columns.push(
			{
				title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
				key: 'attachmentUrls',
				align:'center',
				render: (_,record) => (
					<>
						<Space style={{justifyContent:'center',display:'flex'}} size="middle">
							<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={()=>showEditDrawer(record)}><EditOutlined/></a>
							<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={()=>openDeletesdfosModal(record)}><DeleteOutlined /></a>
						</Space>
					</>
				)
			});
	}


	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	let users=[];
	
	data.users_data && data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});
	

	
	useEffect(() => {
		if(featuresModule.dfosManagementEnabled == false) {
			navigate('/dashboard');
		}
		if(!authtoken){
			navigate('/');
		}
	
	},[authtoken]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4034);

	}, []);
	
	useEffect(() => {
		loaddfoslist();
	}, []);



	let pids=[];

	pidsData && pidsData.map((pid)=>{
		pids.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});

	const loaddfoslist = () => {

		dispatch({ type : DFOS_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/dfosusers?pipelineId=${pipelineId}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
    
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : DFOS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : DFOS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : DFOS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};
	
	
	



	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.dfosinfocontent ? langdata.dfosinfocontent :'This module manages user access for the Distributed Fiber Optic Sensing (DFOS) system.'}</p>
		</Card>
	);


	const showAddDrawer = () => {

		setOpenAddDrawer(true);
		usersList();
		getPids(authtoken);
	};

	const onCloseAddDrawer = () => {
		adddfosformik.resetForm();
		setOpenAddDrawer(false);
	};

	const showEditDrawer = (record) => {
		usersList();
		getPids(authtoken);
		loadfosdetails(record);
		setOpenEditDrawer(true);
		
	};

	const openDeletesdfosModal = (record) => {
		usersList();
		getPids();
		setShowDeleteDfosModal(true);
		loadfosdetails(record);
	};

	const adddfosformik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
			userId:null,
			pidsinfoId:null
	
		},
		onSubmit: (values) => {
	
					
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}
			if (!values.userId || values.userId == null || values.userId === ''|| !values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterusername ? langdata.Pleaseenterusername : 'Please enter user name' });
				return false;
			}
	
			dispatch({type:ADD_DFOS_LIST});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/dfosusers`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					userId:values.userId,
					pidsinfoId:values.pidsinfoId,
					pipelineId : parseInt(pipelineId)
				}
			};
	
			axios
				.request(config)	
				.then((response) => {
						
	
					if (response.status === 200 || response.status === 201) {
	
		
						dispatch( { type: ADD_DFOS_LIST_SUCCESS, payload: response.data.data });
	
						Modal.success({ title: `${langdata && langdata.AdddfosdetailsSuccessfull ? langdata.AdddfosdetailsSuccessfull :'DFOS details added successfully'}` });
						loaddfoslist();
						adddfosformik.resetForm();
						setOpenAddDrawer(false);
	
						
					}
				})
				.catch((error) => {
					if(error.response){
						message.error(`${error.response.data.message}`);
					}
					console.log(error);
						
					dispatch({ type: ADD_DFOS_LIST_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});


	const editdfosformik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
			userId: data?.details?.userId || null,
			pidsinfoId:data?.details?.pidsinfoId || null,
		},
		onSubmit: (values) => {
			dispatch({type:EDIT_DFOS_LIST});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/dfosusers/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					pidsinfoId:Number(values.pidsinfoId),
					userId:values.userId
					
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_DFOS_LIST_SUCCESS});
						Modal.success({ title: `${langdata && langdata.dfosdetailsUpdatedSuccessfully ? langdata.dfosdetailsUpdatedSuccessfully :'DFOS details updated successfully'}` });
						editdfosformik.resetForm();
						setOpenEditDrawer(false);
						loaddfoslist();
					}
				})
				.catch((error) => {
					if(error.response){
						message.error(`${error.response.data.message}`);
					}
					console.log(error);
						
					dispatch({ type: EDIT_DFOS_LIST_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadfosdetails = ((record) => {
		
		dispatch( { type: DFOS_LIST_DETAILS });
			
		if (!record) {
			dispatch({ type: DFOS_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: DFOS_LIST_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		editdfosformik.resetForm();
		setOpenEditDrawer(false);

	};
	const closeDeleteDfosModal = () => {
		setShowDeleteDfosModal(false);
	};

	const deletelist = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_DFOS_LIST });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/dfosusers/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_DFOS_LIST_SUCCESS, payload: response});
					setShowDeleteDfosModal(false);        
					loaddfoslist();
				} else {
					dispatch({type:DELETE_DFOS_LIST_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_DFOS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	


	const usersList = () => {
		
		dispatch({ type : USERS_LIST});
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/users-list?isDeleted=false&usertypeId=14`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : USERS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : USERS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};


	const setUsers = (value,formik)=>{
		
		if(formik === 'add'){
			adddfosformik.setFieldValue('userId',value);
			adddfosformik.setFieldValue('pidsinfoId',null);
		}
		if(formik === 'edit'){

			editdfosformik.setFieldValue('userId',value);
			editdfosformik.setFieldValue('pidsinfoId',null);

		}
	};

	const handleAddFormValuesChange = (changedValues) =>{
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key];
		adddfosformik.setFieldValue('pidsinfoId',val);
	};

	const handleEditFormValuesChange = (changedValues) =>{
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key];
		editdfosformik.setFieldValue('pidsinfoId',val);
	};


	const setName = (e,value) =>{
		if(value === 'add'){
			adddfosformik.setFieldValue('name',e.target.value);
		}

		if(value === 'edit'){
			editdfosformik.setFieldValue('name',e.target.value);

		}

	};



	return (
		<>
			<Content>
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >

					<Col span={8}>
						<Row>

							<Space>
								<ScheduleOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.DFOS ? langdata.DFOS:'Distributed Fiber Optic Sensing (DFOS)'}</Title>
						</Row>
					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
		
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.dfosManagement ? langdata.dfosManagement:'DFOS Management'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.dfos?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.dfos} 
								onChange = { loaddfoslist }
								
								
							/>
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				<Modal
					title={ langdata&&langdata.Adddfosdetails ? langdata.Adddfosdetails : 'Add DFOS details' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={adddfosformik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={adddfosformik.handleSubmit}  >


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} name="name" rules={[{ required: true , message : langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]}>
									<Input 
										name="name"
										onChange={(value) => setName(value,'add') }
										placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }
									/>
								</Form.Item>
							</Col>
						</Row>			

									
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.SelectUsers ? langdata.SelectUsers : 'Select Users'} name="userId" rules={[{ required: true , message : langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users' }]}>
									<Select Item
										name="userId"
										showSearch
										placeholder={langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users'}
										optionFilterProp="children"
										filterOption={filterOption}
										options={users}
										onChange={(e) => setUsers(e,'add') }
									/>
								</Form.Item>
							</Col>
						</Row>			

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required: true, message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
									<Select Item
										name="PIDS"
										style={{ width: '100%'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
										optionFilterProp="children"
										value={adddfosformik.values.pidsinfoId}
										onSelect={(value)=>{handleAddFormValuesChange({'PIDS': value});}}             
										options={pids}
									/>
								</Form.Item>
							</Col>
						</Row>											
					</Form>
				</Modal>

				


				<Modal
					title={langdata && langdata.EditDfosDetails ? langdata.EditDfosDetails:'Edit DFOS details'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editdfosformik.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editdfosformik.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editdfosformik.handleSubmit} layout="vertical"
						// onValuesChange={handleUpdateFormValuesChange}
					>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} name="name" rules={[{ required: true , message : langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]}>
									<Input 
										name="name"
										defaultValue={editdfosformik.values.name}
										onChange={(value) => setName(value,'edit') }
										placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }
									/>
								</Form.Item>
							</Col>
						</Row>			


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.SelectUsers ? langdata.SelectUsers : 'Select Users'} name="userId" rules={[{ required: true , message : langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users' }]}>
									<Select Item
										name="userId"
										showSearch
										placeholder={langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users'}
										defaultValue={editdfosformik?.values.userId}
										optionFilterProp="children"
										filterOption={filterOption}
										options={users}
										onChange={(value) => setUsers(value,'edit') }
									/>
								</Form.Item>
							</Col>
						</Row>	





						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required: true, message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
									<Select Item
										name="PIDS"
										style={{ width: '100%'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
										optionFilterProp="children"
										// value={reportFilter.pidsinfoId}
										defaultValue={editdfosformik.values.pidsinfoId}
										onSelect={(value)=>{handleEditFormValuesChange({'PIDS': value});}}             
										options={pids}
									/>
								</Form.Item>
							</Col>
						</Row>

						
				
									
					</Form>
				</Modal>



				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteDfosModal} onOk={deletelist} onCancel={closeDeleteDfosModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisdfouser ? langdata.AreYouSureYouWantToDeleteThisdfouser : 'Are you sure you want to delete this dfos user' }</Col>
					</Row>
				</Modal>
											
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}